module.exports = __webpack_public_path__ + "static/media/GlacialIndifference-Bold.aff46eae.woff";